/* src/app/home/filter-form/filter-form.component.scss */
.form-bubble {
  position: relative;
  border: 1px solid #757575;
  padding: 19px;
  margin-bottom: 10px;
}
.form-bubble:before {
  content: " ";
  position: absolute;
  width: 0;
  height: 0;
  left: calc(50% + 135px);
  top: -25px;
  border: 12px solid;
  border-color: transparent transparent #757575 transparent;
}
.form-bubble:after {
  content: " ";
  position: absolute;
  width: 0;
  height: 0;
  left: calc(50% + 134px);
  top: -25px;
  border: 14px solid;
  border-color: transparent transparent #fff transparent;
}
.destination-multiselect {
  margin-top: 1rem;
  margin-bottom: 1.5rem;
  position: relative;
  z-index: 1000;
}
.destination-multiselect label {
  margin-bottom: 0.5rem;
  display: block;
}
.destination-column {
  width: 232px;
  height: 260px;
  position: relative;
  top: 37px;
  left: 595px;
  opacity: 1;
  transform: rotate(0deg);
  gap: 64px;
  display: flex;
  flex-direction: column;
}
.form-check {
  padding: 0px 0px 0px 5px;
}
.form-group {
  padding: 0px 0px 0px 5px;
}
.form-group.destination {
  margin-bottom: 65px;
}
.form-group.earliest-date {
  margin-bottom: 18px;
}
.comments,
.trailer-type,
.trailer-direction {
  margin-bottom: 18px;
}
.btn-green {
  background-color: #00857D;
  color: white;
  padding: 5px 35px 5px 35px;
  font-size: 13px;
  border-radius: 16px;
}
.btn-link {
  font-size: 13px;
}
input[type=checkbox] {
  display: none;
}
.form-check label {
  padding: 5px;
  margin-left: -10px;
  white-space: nowrap;
}
.form-check label:before {
  display: inline-block;
  content: "";
  width: 24px;
  height: 24px;
  color: black;
  border: 1px solid #979797;
  border-radius: 4px;
  cursor: pointer;
  vertical-align: middle;
}
input[type=checkbox]:checked + label:before {
  color: #00857D;
  content: "\e622" !important;
  font-size: 11px;
  font-family: upsicons, fantasy !important;
  background: #fff;
  text-align: center;
  line-height: 24px;
  font-weight: bolder;
}
input[type=text] {
  border-radius: 0px;
  border-color: #979797;
}
@media (min-width: 740px) {
  .form-bubble:before {
    left: 302px;
  }
  .form-bubble:after {
    left: 301px;
  }
}
@media (min-width: 1880px) {
  .form-bubble:before {
    left: auto;
    right: 400px;
  }
  .form-bubble:after {
    left: auto;
    right: 397px;
  }
}
/*# sourceMappingURL=filter-form.component.css.map */
